module.exports = __webpack_public_path__ + "static/media/cleaning_map_important.66f87a91.svg";